import { Ng2StateDeclaration, Transition, TransitionService } from '@uirouter/angular';
import { FiDocumentStatesResolvePageTitle } from '@fi-app/document/states/resolve/document-page-title';
import { DocumentTemplateService } from '@fi-app/document-template/document-template.service';
import { DocumentVersionComponent } from '@fi-app/document-version/document-version.component';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { DocumentService } from '@fi-app/document/document.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

export const FiDocumentVersionState: Ng2StateDeclaration = {
    name: FiStateNames.Document.Version,
    url: '/Version/:DocumentId/:VersionId?languageId',
    views: {
        '@': {
            component: DocumentVersionComponent,
        },
    },
    resolve: {
        document: [DocumentService, FiStateService, Transition, FiDocumentVersionStateResolveDocumentResolveFunc],
        templateResponse: [DocumentTemplateService, 'document', FiDocumentVersionStateResolveTemplateResolveFunc],
        selectedVersion: [
            FiStateService,
            '$transition$',
            'document',
            FiDocumentVersionStateResolveSelectedVersionResolveFunc,
        ],
        activeVersion: ['document', 'selectedVersion', FiDocumentVersionStateResolveActiveVersionResolveFunc],
        selectedVersionDocumentControlContents: [
            'document',
            DocumentService,
            'selectedVersion',
            FiDocumentVersionStateResolveDocumentControlContentsResolveFunc,
        ],
        activeVersionDocumentControlContents: [
            'document',
            DocumentService,
            'activeVersion',
            FiDocumentVersionStateResolveDocumentControlContentsResolveFunc,
        ],
        pageTitle: FiDocumentStatesResolvePageTitle,
    },
};

export function FiDocumentVersionStateResolveDocumentResolveFunc(
    documentService: DocumentService,
    fiStateService: FiStateService,
    transition: TransitionService,
) {
    return documentService.GetDocument(fiStateService.getParams(transition).DocumentId);
}

export function FiDocumentVersionStateResolveTemplateResolveFunc(
    documentTemplateService: DocumentTemplateService,
    document,
) {
    return documentTemplateService.GetTemplate(document.TemplateId, { skipAccessCheck: true });
}

export function FiDocumentVersionStateResolveSelectedVersionResolveFunc(
    fiStateService: FiStateService,
    $transition$,
    document,
) {
    const stateVersionId = fiStateService.getParams($transition$).VersionId;
    return document.DocumentVersions.find((item) => item.Id == stateVersionId); // stateVersionId is string
}

export function FiDocumentVersionStateResolveActiveVersionResolveFunc(document, SelectedVersion) {
    let result;
    document.DocumentVersions.forEach((DocumentVersion) => {
        if (
            DocumentVersion.ContentLanguageId == SelectedVersion.ContentLanguageId &&
            DocumentVersion.DocumentVersion > SelectedVersion.DocumentVersion
        ) {
            result = DocumentVersion;
        }
    });
    return result;
}

export function FiDocumentVersionStateResolveDocumentControlContentsResolveFunc(
    document,
    documentService: DocumentService,
    version,
) {
    return documentService.GetDocumentControlContentsVersion(
        document.Id,
        version.DocumentVersion,
        version.ContentLanguageId,
    );
}
